/**
 * Returns a list with stopwords for the Polish passive voice assessment.
 * @returns {Array} The list with stopwords.
 */
export default function() {
	return [
		"a",
		"aby",
		"albo",
		"albowiem",
		"ale",
		"bo",
		"bowiem",
		"czy",
		"gdy",
		"gdyby",
		"gdyż",
		"iż",
		"jeśli",
		"jeżeli",
		"lub",
		"ponieważ",
		"zanim",
		"żeby",
		"który",
		"która",
		"które",
		"którzy",
		"którego",
		"której",
		"których",
		"któremu",
		"którym",
		"którą",
		"którymi",
		"że",
	];
}
